import { useCallback, type ReactNode } from 'react'
import { writeTextToClipboard } from 'shared/lib'
import { type ITooltipProps, Typography, Tooltip, Icon, IconButton, toastStore } from 'shared/ui'

import styles from './styles.module.scss'

interface IRcsInfoFormRowProps {
  tooltipProps?: ITooltipProps
  label: string
  children: ReactNode
  copyValue?: string
}

export const RcsInfoFormRow = ({
  label,
  children,
  tooltipProps,
  copyValue,
}: IRcsInfoFormRowProps) => {
  const handleCopy = useCallback(async () => {
    if (copyValue) {
      await writeTextToClipboard(copyValue)
      toastStore.add({
        title: 'Copied to clipboard',
        type: 'info',
      })
    }
  }, [copyValue])

  return (
    <div className={styles.row}>
      <div className={styles.label}>
        <Typography
          variant={'text-input-field-r'}
          ariaLabel={'RcsInfoFormRowLabel'}
          color='var(--content-primary-secondary)'
          width={tooltipProps ? 'auto' : '188px'}
          ellipsis
          tooltipProps={{
            label: label,
            placement: 'top',
          }}
        >
          {label}
        </Typography>
        {tooltipProps && (
          <Tooltip label={tooltipProps.label} placement='top'>
            <Icon icon='question' color='var(--content-neutral-primary)' fontSize={12} />
          </Tooltip>
        )}
      </div>
      <div className={styles.value}>{children}</div>
      {copyValue && (
        <IconButton
          ariaLabel={'copy'}
          icon={'copy'}
          size={'small'}
          variant={'icon'}
          color={'tertiary'}
          tooltipProps={{
            label: 'Copy link',
            placement: 'top',
          }}
          onClick={handleCopy}
        />
      )}
    </div>
  )
}
